var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico / plaminek"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6485 11.4324H15.7323C15.8162 11.4324 15.7324 11.4324 15.6485 11.4324C12.2118 14.9189 17.4088 20.5946 14.1397 23.027C12.7985 24 10.8706 24.0811 9.69706 22.9459C6.59559 19.8649 10.4515 11.5135 15.6485 11.4324ZM5.84118 15.1622C4.91912 19.4595 6.76324 24 12.1279 24C16.3191 23.9189 18.75 21 18.75 15.2432C18.75 12.7297 16.9897 8.10811 13.8044 4.62162C11.4574 2.02703 8.27206 0 4.5 0C6.26029 1.62162 7.18236 3.4054 7.51765 5.18919C8.43971 9.48649 6.17648 13.6216 5.84118 15.1622Z",
    fill: "#22E06C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1647017b0c7b72f469bf85fd9008d782.svg";
export { ForwardRef as ReactComponent };